import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import {
  getDescription,
  getFakeAddress,
  getFeatured,
  getName,
  getStatus,
  getTitle,
} from '@helpers/helper.developments'
import { RealEstateDataPageComponentData } from 'types'
import useQueryDevelopments from '@hooks/useQueryDevelopments'
import Slider from 'react-slick'
import { Container } from 'react-bootstrap'
import { getTextShort } from '@helpers/helper.rendering'
import Slider_6 from '@boilerplates/sliders/1'
export const NextArrow = (props: any) => {
  return (
    <div
      onClick={props.onClick}
      className="next arrow-custom"
    >
      <i className="icon-arrow-stick-light"></i>
    </div>
  )
}
export const PrevArrow = (props: any) => {
  return (
    <div
      onClick={props.onClick}
      className="prev arrow-custom"
    >
      <i className="icon-arrow-stick-light"></i>
    </div>
  )
}

const settingsSlick: any = {
  dots: true,
  infinite: true,
  speed: 500,
  fade: false,
  slidesToShow: 1,
  centerPadding: 0,
  centerMode: true,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
}

const Summary_Devs_5 = (props: RealEstateDataPageComponentData) => {
  const { global_data, button } = props
  const tokkoKey = global_data.pageConfig.keys.tokko

  const { data: allDevelopmentsData, isLoading } = useQueryDevelopments(tokkoKey)

  const [isComponentMounted, setIsComponentMounted] = useState(false)
  // Component always depends on screen object, so we need to wait until it's mounted
  useEffect(() => {
    setIsComponentMounted(true)
  }, [])

  function makeObject() {
    const objects: {
      photo?: string
      top_string?: string | number
      title?: string
      paragraph?: string
      link?: string
      cta?: string
      btn_image?: string
    }[] = getFeatured(allDevelopmentsData!)?.map((development, i) => {
      return {
        title: getName(development),
        top_string: getStatus(development) || '',
        link:
          (global_data.divisionPath ?? '') +
          '/emprendimiento/' +
          getFakeAddress(development!)?.replaceAll(' ', '-')?.replaceAll('/', '-')?.toLowerCase() +
          '/' +
          development!.id,
        cta: 'VER EMPRENDIMIENTO',
        paragraph: getTextShort(getDescription(development) || '', 200),
        btn_image: button?.image ? button.image : '',
        photo:
          development.photos.find((photo) => photo.is_front_cover)?.original! ||
          development.photos.find((photo) => !photo.is_front_cover)?.original!,
      }
    })
    return objects
  }

  return !isComponentMounted ? null : allDevelopmentsData && <Slider_6 slide_items={makeObject()} />
}

export default Summary_Devs_5
